import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Page, TLCode } from '../../common/enums';
import { ColDef } from 'ag-grid-community';
import { observer } from 'mobx-react';
import DataGrid, {
  Button as DGButton,
  Column,
  DataGridTypes,
  FilterRow,
  FilterPanel,
  Form as DXForm,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  Export,
} from 'devextreme-react/data-grid';
import { ColumnChooser } from 'devextreme-react/cjs/tree-list';

import styled from '@emotion/styled';
import { IconNames } from '@blueprintjs/icons';
import { Spinner, ButtonGroup, Button, Tooltip, Label, Intent, Icon } from '@blueprintjs/core';
import { Position } from '@blueprintjs/core/lib/esm/common/position';
import { Form } from 'react-final-form';
import { PharmacyAnnualReviewSearchCriteria } from '../../store/PharmacyAnnualReviewStore';
import { Pharmacy } from '../../store/models/Pharmacy';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { MessageDialog } from '../common/MessageDialog';
import { AuthenticationStore, BlackPointStore, PharmacyStatusStore } from '../../store';
import { MessageStore } from '../../store/MessageStore';
import { SecretariatStore } from '../../store/SecretariatStore';
import { GroupStore } from '../../store/GroupStore';
import { inject } from 'mobx-react';
import { SEND_MESSAGE } from '@blueprintjs/icons/lib/esm/generated/iconNames';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
import { PharmacyStatusCell } from '../common/grid/PharmacyStatusCell';
import { MessageSelectionMode } from '../../store/models/Message';
import { Tooltip2 } from '@blueprintjs/popover2';
import { getS1, getS2, getSemester, Semester } from '../../common/utils';


interface BlackPointManagerV2Props extends WithTranslateProps {
  missingBlackPoint: any[];
  searchCriteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>;
  onSearch: (criteria: any) => void;
  onChangeCriteria: (direction: number) => void;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  navigate: (url: string) => void;
  setHolCntFilter: (filter: string) => void;
  setLevelFilter: (filter: string) => void;
  setTcOrSpecialBpFilter: (filter: string) => void;
  completionLevelFilter: string;
  levelFilter: string;
  tcOrSpecialBpFilter: string;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  PharmacyStatusStore: Instance<typeof PharmacyStatusStore>;
  MessageStore?: Instance<typeof MessageStore>;
  GroupStore?: Instance<typeof GroupStore>;
  BlackPointStore?: Instance<typeof BlackPointStore>;
}

interface BlackPointManagerV2State {
  missingBlackPoint: any[];
  searchCriteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>;
  isMessageDialogOpen: boolean;
  preloadedRecipientIds: number[];
  isLoading: boolean;
}

@observer
@inject('AuthenticationStore')
@inject('SecretariatStore')
@inject('GroupStore')
@inject('MessageStore')
@inject('PharmacyStatusStore')
@inject('BlackPointStore')
class BlackPointManagerV2 extends React.Component<BlackPointManagerV2Props, BlackPointManagerV2State> {
  state = {
    searchCriteria: this.props.searchCriteria,
    missingBlackPoint: [],
    isMessageDialogOpen: false,
    preloadedRecipientIds: [],
    isLoading: false,
  } as BlackPointManagerV2State;

  _isMounted = false;

  componentDidMount = async () => {
    this._isMounted = true;
  };
  
  buildGridData = () => {
    const { completionLevelFilter, levelFilter, tcOrSpecialBpFilter } = this.props;
    const secretariatId = this.getSecretariatId();
    return this.props.missingBlackPoint
      .filter((mbp) => secretariatId === undefined || mbp.secretariatId === secretariatId)
      .filter((mbp) => {
        let show = true;
        if (completionLevelFilter == 'all') {
          show = mbp.holCnt === 42;
        } else if (completionLevelFilter == 'some') {
          show = mbp.holCnt > 0 && mbp.holCnt < 42;
        } else if (completionLevelFilter == 'none') {
          show = mbp.holCnt === 0;
        } else {
          show = true;
        }
        let show2 = true;
        if (levelFilter == 'one') {
          show2 = mbp.level == 1;
        } else if (levelFilter == 'three') {
          show2 = mbp.level == 3;
        } else if (levelFilter == 'both') {
          show2 = mbp.level > 0;
        }

        let show3 = true;
        if (tcOrSpecialBpFilter == 'all') {
          show3 = mbp;
        } else if (tcOrSpecialBpFilter == 's1') {
          show3 = mbp.statusId == 2 || mbp.specCntS1 > 0;
        } else if (tcOrSpecialBpFilter == 's2') {
          show3 = mbp.statusId == 2 || mbp.specCntS2 > 0;
        }

        if (show && show2 && show3) return mbp;
      })
      .map((mbp) => {
        return {
          ...mbp,
          apbNumber: mbp.apbNumber,
          pharmacyName: mbp.name,
          level: mbp.level,
          status: this.props.PharmacyStatusStore.dataList.find(x => x.pharmacyStatusId == mbp.statusId) ? this.props.PharmacyStatusStore.dataList.find(x => x.pharmacyStatusId == mbp.statusId)!.name : 'unknown'
        };
      });
  };

  buildFilteredGridData = (list) => {
    return list
      .filter((mbp) => this.props.pharmacyList.find((p) => p.pharmacyId === mbp.pharmacyId) !== undefined)
      .map((ss) => ({
        ...ss,
        apbNumber: ss.apbNumber,
        pharmacyName: ss.name,
        level: ss.level,
      }));
  };

  onRowDoubleClicked = (ev) => {
    this.props.navigate(`${Page.PharmacyPage}/${ev.data.pharmacyId}`);
  };

  handleChangeValue = (value) => {
    // this.setState({ searchCriteria: value });
  };

  onStopBP = async (semester : Semester) => {
    const secretariatId = this.getSecretariatId();
    console.log(secretariatId);
    await this.props.BlackPointStore!.stopBPEncoding(semester.end, secretariatId == undefined ? -1 : secretariatId);
  };

  // setHolCntFilter = (value) => {
  //   this.setState({ completionLevelFilter: value});
  // };

  newMessage = () => {
    const { completionLevelFilter, levelFilter, tcOrSpecialBpFilter } = this.props;
    const secretariatId = this.getSecretariatId();
    var missingBlackPointList = this.props.missingBlackPoint
      .filter((mbp) => secretariatId === undefined || mbp.secretariatId === secretariatId)
      .filter((mbp) => {
        let show = true;
        if (completionLevelFilter == 'all') {
          show = mbp.holCnt === 42;
        } else if (completionLevelFilter == 'some') {
          show = mbp.holCnt > 0 && mbp.holCnt < 42;
        } else if (completionLevelFilter == 'none') {
          show = mbp.holCnt === 0;
        } else {
          show = true;
        }
        let show2 = true;
        if (levelFilter == 'one') {
          show2 = mbp.level == 1;
        } else if (levelFilter == 'three') {
          show2 = mbp.level == 3;
        } else if (levelFilter == 'both') {
          show2 = mbp.level > 0;
        }

        let show3 = true;
        if (tcOrSpecialBpFilter == 'all') {
          show3 = mbp;
        } else if (tcOrSpecialBpFilter == 's1') {
          show3 = mbp.statusId == 2 || mbp.specCntS1 > 0;
        } else if (tcOrSpecialBpFilter == 's2') {
          show3 = mbp.statusId == 2 || mbp.specCntS2 > 0;
        }

        if (show && show2 && show3) return mbp;
      })
      .map((mbp) => {
        return {
          ...mbp,
          apbNumber: mbp.apbNumber,
          pharmacyName: mbp.name,
          level: mbp.level,
          status: this.props.PharmacyStatusStore.dataList.find(x => x.pharmacyStatusId == mbp.statusId) ? this.props.PharmacyStatusStore.dataList.find(x => x.pharmacyStatusId == mbp.statusId)!.name : 'unknown'
        };
      });

    var missingBlackPointIdsList = missingBlackPointList.length > 0 ? missingBlackPointList.map(x => x.pharmacyId) : [];

    this.setState({ preloadedRecipientIds: missingBlackPointIdsList });
    this.setState({ isMessageDialogOpen: true });
  };

  saveMessage = async (data: any) => {
    this.setState({ isMessageDialogOpen: false });
    const { completionLevelFilter, levelFilter, tcOrSpecialBpFilter } = this.props;
    const preloaded = this.props.missingBlackPoint
      .filter((mbp) => {
        let show = true;
        if (completionLevelFilter == 'all') {
          show = mbp.holCnt === 42;
        } else if (completionLevelFilter == 'some') {
          show = mbp.holCnt > 0 && mbp.holCnt < 42;
        } else if (completionLevelFilter == 'none') {
          show = mbp.holCnt === 0;
        } else {
          show = true;
        }
        let show2 = true;
        if (levelFilter == 'one') {
          show2 = mbp.level == 1;
        } else if (levelFilter == 'three') {
          show2 = mbp.level == 3;
        } else if (levelFilter == 'both') {
          show2 = mbp.level > 0;
        }

        let show3 = true;
        if (tcOrSpecialBpFilter == 'all') {
          show3 = mbp;
        } else if (tcOrSpecialBpFilter == 's1') {
          show3 = mbp.statusId == 2 || mbp.specCntS1 > 0;
        } else if (tcOrSpecialBpFilter == 's2') {
          show3 = mbp.statusId == 2 || mbp.specCntS2 > 0;
        }
        if (show && show2 && show3) return mbp;
      })
      .map((mbp) => mbp.pharmacyId);
    this.setState({ preloadedRecipientIds: preloaded });
    data.recipientIds = preloaded;
    data.selectionMode = MessageSelectionMode.FromTableResult;

    await this.props.MessageStore!.sendMessage(data);
  };

  sendPreview = (data: any) => {
    return (this.props.MessageStore!.sendPreview(data) as unknown) as boolean;
  };

  getSecretariatId = () => {
    if (this.props.AuthenticationStore!.isSuperAdmin)
      return this.props.SecretariatStore!.selectedSecretariatId === 0
        ? undefined
        : this.props.SecretariatStore!.selectedSecretariatId;
    if (this.props.AuthenticationStore!.isSecretariat) return this.props.AuthenticationStore!.secretariatId!;
    return undefined;
  };

  onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'BilanBlackpoints.xlsx');
      });
    });
  };

  displayPharmacyStatusCell = (params: any) => {
    const pharmacyStatus = this.props.PharmacyStatusStore!.dataList.find(
      (ps) => ps.pharmacyStatusId === params.row.data.statusId,
    );
    if (pharmacyStatus === undefined) return <></>;
    return <PharmacyStatusCell pharmacyStatus={pharmacyStatus} />;
  };

  onChangeCriteria = async (direction: number) => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.onChangeCriteria(direction);
    this._isMounted && this.setState({ isLoading: false });
  };

  render() {
    const { translate, setHolCntFilter, setLevelFilter, setTcOrSpecialBpFilter } = this.props;
    const { preloadedRecipientIds, isLoading } = this.state;
    return (
      <Container>
        <MessageDialog
          isOpen={this.state.isMessageDialogOpen}
          isPreloaded={true}
          preloadedRecipientIds={preloadedRecipientIds}
          onClose={() => this.setState({ isMessageDialogOpen: false })}
          isTest={false}
          save={this.saveMessage}
          pharmacyId={undefined}
          secretariatId={this.getSecretariatId()}
          pharmacyList={this.props.missingBlackPoint}
          groupList={this.props.GroupStore!.dataList}
          translate={translate}
          isSecretariat={this.props.AuthenticationStore!.isSecretariat}
          isSuperAdmin={this.props.AuthenticationStore!.isSuperAdmin}
          canPreview={
            this.props.AuthenticationStore!.isAdmin ||
            this.props.AuthenticationStore!.isSuperAdmin ||
            this.props.AuthenticationStore!.isSecretariat
          }
          onPreviewClick={this.sendPreview}
        />{' '}
        <Form onSubmit={this.props.onSearch} initialValues={{ filter: this.props.searchCriteria }}>
          {() => (
            <ContainerSearchForm style={{ display: 'flex', flexDirection: 'column', marginBottom: '15px' }}>
              <div style={{ display: 'flex', justifyContent: 'left' }}>
                <Tooltip
                  content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_PreviousYear)}
                  position={Position.BOTTOM}
                  hoverOpenDelay={750}
                >
                  <Button
                    icon={IconNames.CHEVRON_LEFT}
                    large={true}
                    style={{ height: '30px', marginRight: '5px' }}
                    onClick={() => this.onChangeCriteria(-1)}
                  />
                </Tooltip>
                <Label
                  style={{
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    fontSize: '25px',
                    verticalAlign: 'center',
                  }}
                >
                  {this.props.searchCriteria.year}
                </Label>
                <Tooltip
                  content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_ThisYear)}
                  position={Position.BOTTOM}
                  hoverOpenDelay={750}
                >
                  <Button
                    icon={IconNames.CHEVRON_DOWN}
                    large={true}
                    style={{ height: '30px', marginLeft: '5px' }}
                    onClick={() => this.onChangeCriteria(0)}
                  />
                </Tooltip>
                <Tooltip
                  content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_NextYear)}
                  position={Position.BOTTOM}
                  hoverOpenDelay={750}
                >
                  <Button
                    icon={IconNames.CHEVRON_RIGHT}
                    large={true}
                    style={{ height: '30px', marginLeft: '5px' }}
                    onClick={() => this.onChangeCriteria(1)}
                  />
                </Tooltip>
                <Button
                  text={"Stop S1 " + this.props.searchCriteria.year}
                  style={{ height: '30px', marginLeft: '5px' }}
                  intent={Intent.DANGER}
                  onClick={() => this.onStopBP(getS1(this.props.searchCriteria.year!))}
                />
                <Button
                  text={"Stop S2 " + this.props.searchCriteria.year}
                  style={{ height: '30px', marginLeft: '5px' }}
                  intent={Intent.DANGER}
                  onClick={() => this.onStopBP(getS2(this.props.searchCriteria.year!))}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <span>
                    <b>
                      <TranslatedMessage id={TLCode.BLACKPOINTS_HolCntFilterLabel} />
                      &nbsp;&nbsp;
                    </b>
                    <ButtonGroup>
                      <Button
                        text={translate(TLCode.FILTER_All)}
                        onClick={() => setHolCntFilter('any')}
                        active={this.props.completionLevelFilter === 'any'}
                      />{' '}
                      <Button
                        text={translate(TLCode.BLACKPOINTS_HolCnt_All)}
                        onClick={() => setHolCntFilter('all')}
                        active={this.props.completionLevelFilter === 'all'}
                      />
                      <Button
                        text={translate(TLCode.BLACKPOINTS_HolCnt_Some)}
                        onClick={() => setHolCntFilter('some')}
                        active={this.props.completionLevelFilter === 'some'}
                      />
                      <Button
                        text={translate(TLCode.BLACKPOINTS_HolCnt_None)}
                        onClick={() => setHolCntFilter('none')}
                        active={this.props.completionLevelFilter === 'none'}
                      />
                    </ButtonGroup>
                  </span>

                  <span>
                    <b style={{ marginLeft: '20px' }}>
                      &nbsp;&nbsp;
                      <TranslatedMessage id={TLCode.BLACKPOINTS_LevelFilterLabel} />
                      &nbsp;&nbsp;
                    </b>
                    <ButtonGroup>
                      <Button
                        text={translate(TLCode.PHARMACIES_Three)}
                        onClick={() => setLevelFilter('three')}
                        active={this.props.levelFilter === 'three'}
                      />
                      <Button
                        text={translate(TLCode.PHARMACIES_One)}
                        onClick={() => setLevelFilter('one')}
                        active={this.props.levelFilter === 'one'}
                      />
                      {/* <Button
                        text={translate(TLCode.PHARMACIES_Zero)}
                        onClick={() => setLevelFilter('zero')}
                        active={this.props.levelFilter === 'zero'}
                      /> */}
                      <Button
                        text={translate(TLCode.FILTER_All)}
                        onClick={() => setLevelFilter('both')}
                        active={this.props.levelFilter === 'both'}
                      />
                    </ButtonGroup>
                  </span>

                  <span>
                    <b style={{ marginLeft: '20px', marginRight: '5px' }}>
                      {translate(TLCode.BLACKPOINTS_FilterOnTcOrSpecs)}
                    </b>
                    <Tooltip2
                      content={
                        <div style={{ maxWidth: '200px' }}>
                          <TranslatedMessage id={TLCode.BLACKPOINTS_FilterOnTcOrSpecs_Tooltip} />
                        </div>
                      }
                      position={Position.RIGHT}
                    >
                      <Icon icon="help" />
                    </Tooltip2>
                    <ButtonGroup style={{ marginLeft: '5px' }}>
                      <Tooltip
                        content={translate(TLCode.BLACKPOINTS_FilterOnTcOrSpecsS1_Tooltip)}
                        position={Position.BOTTOM}
                        hoverOpenDelay={750}
                      >
                        <Button
                          text={translate(TLCode.BLACKPOINTS_FilterOnTcOrSpecsS1)}
                          onClick={() => setTcOrSpecialBpFilter('s1')}
                          active={this.props.tcOrSpecialBpFilter === 's1'}
                        />
                      </Tooltip>
                      <Tooltip
                        content={translate(TLCode.BLACKPOINTS_FilterOnTcOrSpecsS2_Tooltip)}
                        position={Position.BOTTOM}
                        hoverOpenDelay={750}
                      >
                        <Button
                          text={translate(TLCode.BLACKPOINTS_FilterOnTcOrSpecsS2)}
                          onClick={() => setTcOrSpecialBpFilter('s2')}
                          active={this.props.tcOrSpecialBpFilter === 's2'}
                        />
                      </Tooltip>
                      <Button
                        text={translate(TLCode.FILTER_All)}
                        onClick={() => setTcOrSpecialBpFilter('all')}
                        active={this.props.tcOrSpecialBpFilter === 'all'}
                      />
                    </ButtonGroup>
                  </span>
                </div>

                <div>
                  <Button
                    icon={SEND_MESSAGE}
                    text={translate(TLCode.MESSAGE_NewMessage)}
                    intent={Intent.PRIMARY}
                    onClick={() => this.newMessage()}
                    style={{ width: '170px' }}
                    hidden={
                      !(
                        this.props.AuthenticationStore!.isSecretariat ||
                        this.props.AuthenticationStore!.isAdmin ||
                        this.props.AuthenticationStore!.isSuperAdmin
                      )
                    }
                  />
                </div>
              </div>
            </ContainerSearchForm>
          )}
        </Form>
        {this.props.missingBlackPoint && (
          <Container>
            <DivLine>
              <DivColumn>
{isLoading ? (
              <SpinnerContainer>
                <Spinner intent={Intent.PRIMARY} size={Spinner.SIZE_STANDARD} />
              </SpinnerContainer>
            ) : (
              <>                <DataGrid
                  //dataSource={this.props.missingBlackPoint}
                  dataSource={this.buildGridData()}
                  allowColumnReordering={true}
                  rowAlternationEnabled={true}
                  showBorders={true}
                  width="100%"
                  allowColumnResizing={true}
                  columnResizingMode={'widget'}
                  onExporting={this.onExporting}
                  onRowDblClick={this.onRowDoubleClicked}
                >
                  {/* <Editing mode="popup" allowUpdating={true} allowAdding={false} allowDeleting={false}>
                    <Popup title="test" showTitle={true} />
                    <DXForm>
                      <GroupItem>
                        <SimpleItem dataField='body'></SimpleItem>
                      </GroupItem>
                    </DXForm>
                  </Editing> */}
                  <Export enabled={true} />
                  <FilterRow visible={true} applyFilter={'auto'} />
                  <FilterPanel visible={true} />
                  <HeaderFilter visible={true} />
                  <GroupPanel visible={true} />
                  <SearchPanel visible={true} highlightCaseSensitive={true} />
                  <Grouping autoExpandAll={false} />
                  <ColumnChooser enabled={true} />
                  <Column
                    dataField="level"
                    caption=""
                    dataType="number"
                    alignment="center"
                    width={25}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="apbNumber"
                    caption={this.props.translate(TLCode.PHARMACY_ApbNr)}
                    dataType="string"
                    alignment="center"
                    cssClass="bullet"
                    width={80}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                    allowFiltering={true}
                  />
                  <Column
                    dataField="holCnt"
                    caption={this.props.translate(TLCode.BLACKPOINTS_HolCnt)}
                    dataType="number"
                    alignment="left"
                    cssClass="bullet"
                    width={45}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="holCntS1"
                    caption={this.props.translate(TLCode.BLACKPOINTS_HolCntS1)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={59}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="holCntS2"
                    caption={this.props.translate(TLCode.BLACKPOINTS_HolCntS2)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={59}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="ecoCnt"
                    caption={this.props.translate(TLCode.BLACKPOINTS_EcoCnt)}
                    dataType="number"
                    alignment="left"
                    cssClass="bullet"
                    width={49}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="ecoCntS1"
                    caption={this.props.translate(TLCode.BLACKPOINTS_EcoCntS1)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={64}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="ecoCntS2"
                    caption={this.props.translate(TLCode.BLACKPOINTS_EcoCntS2)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={64}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="sickCnt"
                    caption={this.props.translate(TLCode.BLACKPOINTS_SickCnt)}
                    dataType="number"
                    alignment="left"
                    cssClass="bullet"
                    width={54}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="sickCntS1"
                    caption={this.props.translate(TLCode.BLACKPOINTS_SickCntS1)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={69}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="sickCntS2"
                    caption={this.props.translate(TLCode.BLACKPOINTS_SickCntS2)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={69}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="specCnt"
                    caption={this.props.translate(TLCode.BLACKPOINTS_SpecCnt)}
                    dataType="number"
                    alignment="left"
                    cssClass="bullet"
                    width={55}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="specCntS1"
                    caption={this.props.translate(TLCode.BLACKPOINTS_SpecCntS1)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={70}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="specCntS2"
                    caption={this.props.translate(TLCode.BLACKPOINTS_SpecCntS2)}
                    dataType="number"
                    alignment="left"
                    cssClass="ColumnsAutomatic"
                    width={70}
                    allowResizing={false}
                    allowHeaderFiltering={true}
                  />
                  <Column
                    dataField="status"
                    cellRender={this.displayPharmacyStatusCell}
                    caption={this.props.translate(TLCode.PHARMACY_Status)}
                    dataType="string"
                    alignment="center"
                    allowResizing={false}
                    width={'auto'}
                  />
                  <Column
                    dataField="name"
                    caption={this.props.translate(TLCode.PHARMACY)}
                    dataType="string"
                    alignment="left"
                    allowResizing={true}
                    width={'auto'}
                  />
                  <Column
                    dataField="address"
                    caption={this.props.translate(TLCode.PHARMACIES_Address)}
                    dataType="string"
                    alignment="left"
                    allowResizing={true}
                    width={'auto'}
                  />
                  <Column
                    dataField="zipCode"
                    caption={this.props.translate(TLCode.PHARMACIES_ZipCode)}
                    dataType="string"
                    alignment="left"
                    allowResizing={false}
                    width={60}
                  />
                  <Column
                    dataField="city"
                    caption={this.props.translate(TLCode.PHARMACIES_City)}
                    dataType="string"
                    alignment="left"
                    allowResizing={true}
                    width={90}
                  />
                  <Pager
                    visible={true}
                    allowedPageSizes={[5, 10, 20, 50, 100]}
                    showPageSizeSelector={true}
                    showInfo={true}
                    showNavigationButtons={true}
                  />
                  <Paging defaultPageSize={20} />
                </DataGrid>
                {/* <BaseGridXL
                  columnDefs={this.columns}
                  rowData={this.buildGridData()}
                  keyName={'pharmacyId'}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  suppressClickEdit={true}
                /> */}
                </>
                )}
              </DivColumn>
            </DivLine>
          </Container>
        )}
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerSearchForm = styled.div`
  display: flex;
  flex: 0;
  flex-direction: row;
  .bp3-form-content {
    margin-right: 5px;
  },
`;

const ContainerGrid = styled.div`
  display: flex;
  flex-direction: row;
  width: 400px;
  flex: 1;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`;

const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
  padding-bottom: 5px;
`;

const DivRight = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  justify-content: flex-end;
  .bp3-icon {
    margin-right: 3px;
  }
`;


const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export default withTranslate(BlackPointManagerV2);
